export enum CommunicationTargetType {
  everyone = "everyone",
  store = "stores",
  groups = "groups",
  roles = "roles",
}
